module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "docs"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "doclist"
  }, [_vm._l((_vm.docs), function(doc, index) {
    return (!_vm.currentDoc) ? _c('div', {
      key: index
    }, [_c('foldable', {
      attrs: {
        "minHeight": 50,
        "async": ""
      },
      on: {
        "toggle": function($event) {
          _vm.selectDoc(index, $event)
        }
      }
    }, [_c('div', {
      staticClass: "doc",
      style: ({
        'background-color': doc.isCollapsed ? 'lightgrey' : 'ghostwhite'
      }),
      attrs: {
        "id": 'doc' + index
      },
      domProps: {
        "innerHTML": _vm._s(doc.html)
      }
    })]), _vm._v(" "), _c('hr')], 1) : _vm._e()
  }), _vm._v(" "), (_vm.currentDoc) ? _c('div', {
    staticClass: "currentDoc"
  }, [_c('button', {
    staticClass: "close pull-right",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeDoc()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentDoc.html)
    }
  })]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('span', [_c('i', {
    staticClass: "fa fa-lg fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(" Documentation")])]), _vm._v(" "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92b8fb28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/about/About.vue
// module id = 213
// module chunks = 5